import { render } from "./UserDropdown.vue?vue&type=template&id=4a884c60&scoped=true&ts=true"
import script from "./UserDropdown.vue?vue&type=script&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&lang=ts"

import "./user-dropdown.scss?vue&type=style&index=0&id=4a884c60&lang=scss&scoped=true"
import "./user-dropdown-global.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a884c60"]])

export default __exports__